<template>
  <v-dialog
    v-model="internalShow"
    :persistent="true"
    maxWidth="700"
    @click:outside="onClickOutside"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('administration.termsOfUse') }}
      </v-card-title>
      <v-divider class="mb-4" />
      <template v-if="!showDeclineConfirmation">
        <v-card-text>
          <div
            ref="termsContent"
            style="overflow-y: auto; max-height: 500px;"
            @scroll="checkScroll"
          >
            <div v-html="message" />
          </div>
        </v-card-text>
        <v-card-actions
          v-if="hasScrolledToBottom"
          class="justify-space-between"
        >
          <v-btn
            color="red"
            text
            @click="showDeclineConfirmation = true"
          >
            {{ $t('forms.labels.decline') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            dark
            @click="accept"
          >
            {{ $t('forms.labels.agree') }}
          </v-btn>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-text>
          <div style="display: flex; align-items: center; margin-bottom: 16px;">
            <v-icon
              color="error"
              left
            >
              mdi-alert-circle-outline
            </v-icon>
            <span style="font-weight: bold; font-size: 1.1em; margin-left: 8px;">{{ $t('forms.modal.termsDeclineConfirmTitle') }}</span>
          </div>
          <div style="margin-bottom: 16px;">
            {{ $t('forms.modal.termsDeclineConfirmMessage') }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="decline"
          >
            {{ $t('forms.labels.decline') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            dark
            @click="accept"
          >
            {{ $t('forms.modal.termsAccept') }}
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'TermsModal',
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            internalShow: this.show,
            showDeclineConfirmation: false,
            hasScrolledToBottom: false,
        };
    },
    watch: {
        internalShow(val) {
            if (val && !this.showDeclineConfirmation) {
                this.hasScrolledToBottom = false;
                this.$nextTick(() => {
                    const termsDiv = this.$refs.termsContent;
                    if (termsDiv && termsDiv.scrollHeight > termsDiv.clientHeight) {
                        termsDiv.scrollTop = 0;
                    }
                });
            }
            if (!val) {
                this.$emit('close');
            }
        },
    },
    mounted() {
        const termsDiv = this.$refs.termsContent;
        if (termsDiv.scrollHeight <= termsDiv.clientHeight) {
            this.hasScrolledToBottom = true;
        } else {
            this.hasScrolledToBottom = false;
        }
    },
    methods: {
        decline() {
            this.$emit('action', 'decline');
            this.internalShow = false;
        },
        accept() {
            this.$emit('action', 'accept');
            this.showDeclineConfirmation = false;
            this.internalShow = false;
        },
        onClickOutside() {
        },
        checkScroll() {
            const termsDiv = this.$refs.termsContent;
            if (!termsDiv) return;
            this.hasScrolledToBottom = termsDiv.scrollTop + termsDiv.clientHeight >= termsDiv.scrollHeight - 2;
        },
    },
};
</script>
